module.exports = __webpack_public_path__ + "static/media/received.b065229b.png";